import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class SubdomainService {
  #platformId = inject(PLATFORM_ID);

  #getSubdomain(): string {
    if (!isPlatformBrowser(this.#platformId)) {
      return '';
    }
    const hostname = window.location.hostname;
    return hostname.split('.')[0] ?? '';
  }

  isFamilySubdomain(): boolean {
    return this.#getSubdomain() === 'family';
  }

  isSchoolSubdomain(): boolean {
    return this.#getSubdomain() === 'school';
  }

  isAdminSubdomain(): boolean {
    return this.#getSubdomain() === 'admin';
  }

  isPatrolSubdomain(): boolean {
    return this.#getSubdomain() === 'patrol';
  }

  isOAuthSubdomain(): boolean {
    return this.#getSubdomain() === 'oauth';
  }
}
